import * as React from 'react'
import { createComponent } from '@cloudflare/style-container'
import { MonacoEditor } from './MonacoEditor'
import { types as editorCustomTypesString } from './FiddleEditor-Types'

export interface IFiddleEditorProps {
  value: string
  editorDidMount?: (
    editor: monaco.editor.ICodeEditor,
    code: typeof monaco,
  ) => void
}

export interface IFiddleEditorState {}

export class FiddleEditor extends React.Component<
  IFiddleEditorProps,
  IFiddleEditorState
> {
  public static defaultProps = {
    value: '',
  }

  constructor(props: IFiddleEditorProps) {
    super(props)

    this.onChange = this.onChange.bind(this)
    this.editorDidMount = this.editorDidMount.bind(this)
    this.editorWillMount = this.editorWillMount.bind(this)
  }

  editorWillMount(code: typeof monaco) {
    code.languages.typescript.javascriptDefaults.setDiagnosticsOptions({
      noSemanticValidation: true,
      noSyntaxValidation: false,
    })

    monaco.languages.typescript.javascriptDefaults.addExtraLib(
      editorCustomTypesString,
      'extended-events.d.ts',
    )
  }

  editorDidMount(editor: monaco.editor.ICodeEditor, code: typeof monaco) {
    editor.focus()

    if (typeof this.props.editorDidMount === 'function') {
      this.props.editorDidMount(editor, code)
    }
  }

  onChange(
    event: monaco.editor.IModelContentChangedEvent,
    editor: monaco.editor.ICodeEditor,
  ) {}

  render() {
    return (
      <FiddleWrapper>
        <MonacoEditor
          value={this.props.value}
          pathToMonaco="/ui/staging/vs"
          selectOnLineNumbers={true}
          language="javascript"
          minimap={{ enabled: false }}
          folding={true}
          onChange={this.onChange}
          editorWillMount={this.editorWillMount}
          editorDidMount={this.editorDidMount}
        />
      </FiddleWrapper>
    )
  }
}

const FiddleWrapper = createComponent(() => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  position: 'relative',
  width: '100%',
  height: '100%',
}))



// WEBPACK FOOTER //
// ./src/components/FiddleEditor.tsx